module.exports = __webpack_public_path__ + "img/tv.51ef33fb.jpg";